import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import {
  ComboData
} from "src/app/modules/slotted-perforated-pipe/shared/slotted-modal/models/dcp-modal";
import { DcpShortNames } from "../../../../enums/dcp-short-names.enum";

@Component({
  selector: "app-main-filters",
  templateUrl: "./main-filters.component.html",
  styleUrls: ["./main-filters.component.css"],
})
export class MainFiltersComponent implements OnInit {
  @Output() changeMainFilters = new EventEmitter();
  @Output() outsideDiameterChanged = new EventEmitter<string>();
  @Output() wallThicknessChanged = new EventEmitter<string>();

  @Input() fgFilters: UntypedFormGroup;
  @Input() filters: { [key in DcpShortNames]: ComboData[] };
  @Input() isLoadingFilters: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.fgFilters.get("fgMainFilters").valueChanges.subscribe(() => {
      this.changeMainFilters.emit(this.fgFilters.get("fgMainFilters").valid);
    });

    // Listen for individual OD changes (including deselection)
    this.fgFilters.get("fgMainFilters").get("outsideDiameter").valueChanges.subscribe((value) => {
      this.outsideDiameterChanged.emit(value); // Emit even if value is null
    });

    // Listen for individual WT changes (including deselection)
    this.fgFilters.get("fgMainFilters").get("wallThickness").valueChanges.subscribe((value) => {
      this.wallThicknessChanged.emit(value); // Emit even if value is null
    });
  }

  public get dcpShortNames(): typeof DcpShortNames {
    return DcpShortNames;
  }
}
